function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copyright">
        &copy;&nbsp;2022 Card gallery Дмитрий Рябов
      </p>
    </footer>
  );
}

export default Footer;
